"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drawerVars = exports.drawerStyles = exports.drawerCommon = exports.WIDTH_UNSET = exports.HEIGHT_UNSET = void 0;
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var HEIGHT_UNSET = exports.HEIGHT_UNSET = "heightUnset";
var WIDTH_UNSET = exports.WIDTH_UNSET = "widthUnset";
var drawerCommon = exports.drawerCommon = ["height", "maxHeight", "minHeight", "width", "maxWidth", "minWidth", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "top", "bottom", "left", "right", "zIndex"];
var drawerVars = exports.drawerVars = (0, _initVars.default)({
  applied: drawerCommon,
  variables: [{
    key: "drawerTransform"
  }]
});
var drawerStyles = exports.drawerStyles = function drawerStyles(theme) {
  var _ref;
  return _ref = {
    variables: drawerVars.styles,
    root: {},
    contents: {
      display: "block",
      padding: 0,
      minWidth: 0,
      background: theme.colors.themeBase,
      color: theme.colors.baseContrast100,
      borderRadius: 0,
      borderWidth: 0,
      maxWidth: "100%",
      maxHeight: "100%",
      overflowY: "auto",
      transform: drawerVars.get("drawerTransform"),
      position: "fixed"
    }
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, HEIGHT_UNSET, {
    height: "unset"
  }), WIDTH_UNSET, {
    width: "unset"
  }), "disableOverlay", {
    display: "none"
  }), "topPadding", {
    paddingTop: theme.spacing.base * 5
  }), "top", {
    top: 0,
    height: "auto",
    width: "100%"
  }), "bottom", {
    bottom: 0,
    height: "auto",
    width: "100%"
  }), "left", {
    insetInlineStart: 0,
    height: "100%",
    width: "auto"
  }), "right", {
    insetInlineEnd: 0,
    height: "100%",
    width: "auto"
  }), "@keyframes DrawerOpen", {
    "0%": {
      opacity: 0
    },
    "100%": {
      transform: "translate(0px, 0px)"
    }
  }), "@keyframes DrawerClose", {
    "0%": {
      transform: "inherit"
    },
    "100%": {
      opacity: 0
    }
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "@global", {
    "@keyframes DrawerCloseGentle": {
      "100%": {
        boxShadow: "none"
      }
    }
  }), "drawerOpen", {
    animation: "200ms cubic-bezier(0.4, 0, 0.2, 1) normal forwards $DrawerOpen"
  }), "drawerClose", {
    animation: "200ms cubic-bezier(0.4, 0, 0.2, 1) normal forwards $DrawerClose"
  }), "gentleClose", {
    animation: "200ms cubic-bezier(0.4, 0, 0.2, 1) normal forwards $DrawerCloseGentle"
  });
};